<bw-modal-legacy>
  <typography-legacy title-medium>{{title | translate}}</typography-legacy>
  <div class="body"><bw-paragraph-legacy>{{prompt | translate}}</bw-paragraph-legacy></div>
  <div class="footer">
    <button bw-button-legacy #btnRef (click)="dismiss()">{{ctaText | translate}}</button>
  </div>
</bw-modal-legacy>
